import styled from 'styled-components';
import { Skeleton } from '#/shared/components/Skeletons/styled';

export const StopListSkeletonWrapper = styled.div`
  align-items: center;
  display: flex;
  flex: 0;
  margin: 0.5em;
`;

export const StopListCircleSkeleton = styled(Skeleton).attrs(() => ({
  circle: true,
  containerClassName: 'basic-flex',
  enableAnimation: false,
  height: '32px',
  width: '32px',
}))`
  && {
    margin-right: 0.5em;
  }
`;

export const StopListLongSkeleton = styled(Skeleton).attrs(() => ({
  borderRadius: '0.5rem',
  containerClassName: 'skeleton-flex-1',
}))``;
